import { Box, Card, Grid, SxProps, Theme, Typography } from '@mui/material';

const sx_card: SxProps<Theme> = {
	padding: '8px',
	border: '3px solid darkgray',
	margin: '2px',
	width: '346px',
	height: '75px',
};

const sx_grid: SxProps<Theme> = {
	width: '100%',
	justifyContent: 'center',
	alignItems: 'center',
	textAlign: 'center',
};

const sx_name: SxProps<Theme> = {
	width: '100%',
};

interface Props {
	name: string;
}

export const ResumeDisplay: React.FC<Props> = (props) => {
	const { name } = props;

	return (
		<Card sx={sx_card}>
			<Grid container sx={sx_grid}>
				<Box sx={sx_name}>
					<Typography variant='h4'>{name}</Typography>
				</Box>
			</Grid>
		</Card>
	);
};
